import Highcharts from 'highcharts/highstock';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/accessibility';
import _ from 'lodash';

if (typeof Highcharts?.setOptions !== 'function') {
  throw new Error('Highcharts nicht geladen, bevor app.js ausgeführt wurde');
}

function AMApp() {
}


/**
 * Constants
 */
AMApp.LOADING_ANIMATION = '<div class="loader"><div class="loader-circle"></div></div>';

/**
 * Route dev check
 */
AMApp.basePath = window.location.origin;

/**
 *
 * @type {string}
 */
AMApp.inputDateFormatHighCharts = '%Y-%m-%d';
AMApp.momentDateFormat = 'YYYY-MM-DD';

/**
 * Language
 */
AMApp.lang = document.documentElement.lang.toLowerCase();
AMApp.langGetParam = '?L=en&';

if (AMApp.lang === 'de' || AMApp.lang === 'de-de') {
  AMApp.lang = 'de';
  AMApp.isGerman = true;
  AMApp.langGetParam = '?';
  AMApp.inputDateFormatHighCharts = '%d.%m.%Y';
  AMApp.momentDateFormat = 'DD.MM.YYYY';
} else {
  AMApp.lang = 'en';
}

/**
 * Convert handlebars delimiters
 *
 * @param str
 * @returns {*}
 */
AMApp.prototype.toHandlebarsDelimiters = function toHandlebarsDelimiters(str) {
  return str
    .replaceAll('[[[', '{{{')
    .replaceAll(']]]', '}}}')
    .replaceAll('[[', '{{')
    .replaceAll(']]', '}}');
};

AMApp.translation = {
  de: {
    common: {
      noService: 'Entschuldigung, momentan ist dieser Service nicht verfügbar. Bitte probieren Sie es später wieder!',
      noIsin: 'Es ist keine ISIN vorhanden!',
      printTxt: 'Drucken',
      loadData: 'Lade Daten vom Server ...'
    },
    fondsdetail: {
      noResultMessage: 'Kein Fonds gefunden!',
      loadingDataText: 'Lade Daten ...',
      chartValuePerformance: 'Wertentwicklung',
      chartPricePerformance: 'Preisentwicklung'
    },
    home: {
      fondsOfTheMonthNotFound: 'Kein Top Fonds des Monats vorhanden.'
    },
    response: {
      noResult: 'Keine Fonds gefunden!',
      fail: 'Ihre Anfrage konnte nicht verarbeitet werden. Bitte probieren Sie es später wieder!'
    },
    fondsrecommendation: {
      key: 'Portfoliostruktur',
      title: 'Fondszusammensetzung'
    }
  },
  en: {
    common: {
      noService: 'Sorry, this service is currently not available. Please try it again later!',
      noIsin: 'No ISIN is given!',
      printTxt: 'Print',
      loadData: 'Loading data from server ...'
    },
    fondsdetail: {
      noResultMessage: 'No fonds found!',
      loadingDataText: 'Loading data ...',
      chartValuePerformance: 'Value performance',
      chartPricePerformance: ' Price performance'
    },
    home: {
      fondsOfTheMonthNotFound: 'No fond of the month found.'
    },
    response: {
      noResult: 'No fonds found!',
      fail: 'Ihre Anfrage konnte nicht verarbeitet werden. Bitte probieren Sie es später wieder!'
    },
    fondsrecommendation: {
      key: 'Portfolio structure',
      title: 'Fondszusammensetzung'
    }
  }
};

/**
 * Highcharts defaults
 */
Highcharts.setOptions({
  global: {
    useUTC: false
  },
  credits: {
    enabled: false
  },
  lang: {
    rangeSelectorZoom: ''
  },
  rangeSelector: {
    inputDateFormat: AMApp.inputDateFormatHighCharts,
    inputEditDateFormat: AMApp.inputDateFormatHighCharts,
  },
  chart: {
    style: {
      fontFamily: 'ClanPro, sans-serif'
    }
  }
});

// Set the datepicker's language
if (AMApp.isGerman) {
  AMApp.datepickerOptions = {
    prevText: '&#x3c;zurück',
    prevStatus: '',
    prevJumpText: '&#x3c;&#x3c;',
    prevJumpStatus: '',
    nextText: 'Vor&#x3e;',
    nextStatus: '',
    nextJumpText: '&#x3e;&#x3e;',
    nextJumpStatus: '',
    currentText: 'heute',
    currentStatus: '',
    todayText: 'heute',
    todayStatus: '',
    clearText: '-',
    clearStatus: '',
    closeText: 'schließen',
    closeStatus: '',
    monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
      'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun',
      'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    //showMonthAfterYear: false,
    //showOn: 'both',
    dateFormat: 'dd.mm.yy'
  };

  Highcharts.setOptions({
    lang: {
      decimalPoint: ',',
      thousandsSep: '.',
      loading: 'Daten werden geladen...',
      months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
      shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
      exportButtonTitle: 'Exportieren',
      printButtonTitle: 'Drucken',
      rangeSelectorFrom: 'Von',
      rangeSelectorTo: 'Bis',
      rangeSelectorZoom: 'Zeitraum',
      downloadPNG: 'Download als PNG-Bild',
      downloadJPEG: 'Download als JPEG-Bild',
      downloadPDF: 'Download als PDF-Dokument',
      downloadSVG: 'Download als SVG-Bild',
      resetZoom: 'Zoom zurücksetzen',
      resetZoomTitle: 'Zoom zurücksetzen'
    }
  });
} else {
  AMApp.datepickerOptions = {
    dateFormat: 'yy-mm-dd'
  };
}

AMApp.translations = {};
if (AMApp.isGerman) {
  Object.assign(AMApp.translations, AMApp.translation.de);
} else {
  Object.assign(AMApp.translations, AMApp.translation.en);
}


AMApp.CONSTANTS = {
  BREAKPOINT: {
    SM: 576,
    MD: 768,
    LG: 992,
    XL: 1200
  }
};

/**
 * Check if insti or not
 * @returns {boolean}
 */
AMApp.prototype.isInstitutionell = function isInstitutionell() {
  return /\/institutionell\//.test(window.location.pathname) || !!document.querySelector('[data-insti="true"]');
};

/**
 * Get retail fonds
 *
 * @param fondsDocs
 */
AMApp.prototype.getRetailFonds = function getRetailFonds(fondsDocs) {
  // removes highlighting strings
  fondsDocs = fondsDocs.map(doc => {
    const temp = document.createElement('div');
    temp.innerHTML = doc['INSD_NAME'];
    doc['INSD_NAME'] = temp.innerText;
    temp.innerHTML = doc['INSD_ISIN'];
    doc['INSD_ISIN'] = temp.innerText;

    return doc;
  });

  return _.filter(fondsDocs, { INSD_ZIELGRUPPE: 'R' });
};

/**
 * Get insti fonds
 *
 * @param fondsDocs
 */
AMApp.prototype.getInstiFonds = function getRetailFonds(fondsDocs) {
  return _.filter(fondsDocs, { INSD_ZIELGRUPPE: 'I' });
};


const amApp = new AMApp();
window.AMApp = AMApp;
export default AMApp;